import React, { useEffect, useState } from "react";
import { FaGlobe } from "react-icons/fa";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
const scrollToTop = () => {
  window.scrollTo({ top: 0, behavior: "smooth" });
};

// Spinner Component
const Spinner = () => (
  <div className="flex items-center justify-center min-h-screen bg-black bg-opacity-90">
    <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-yellow-400 border-solid"></div>
  </div>
);

function AboutAstrology({ language }) {
  const [data, setData] = useState(null);
  const [imageLoaded, setImageLoaded] = useState(false);

  useEffect(() => {
    const img = new Image();
    img.src = "/image/bg/Astrology__bg.webp"; // Ensure correct path
    img.onload = () => setImageLoaded(true);
  }, []);

  useEffect(() => {
    fetch("/data.json")
      .then((response) => response.json())
      .then((json) => setData(json))
      .catch((error) => console.error("Error loading data:", error));
  }, []);

  if (!data) {
    return <Spinner />;
  }

  return (
    <>
      <Helmet>
        <title>About Astrology || ज्योतिष विद्या </title>
        <meta
          name="description"
          content="Guidance inspires us for success, personal development, and career growth. It helps us achieve our life goals, overcome challenges, and unlock our true potential, leading to self-satisfaction and inner fulfillment. Therefore, we should be drawn to expert guidance and mentorship, as they provide the tools and insights needed to navigate life’s journey effectively."
        />
        <meta
          name="keywords"
          content="Guidance, Success , Personal development , Career growth , Life goals , Self-satisfaction , Inner fulfillment , Expert guidance , Mentorship"
        />
        <meta property="og:title" content="About Astrology || ज्योतिष विद्या" />
        <meta
          property="og:description"
          content="Discover personalized astrology services."
        />
        <meta property="og:url" content="https://astromahamaya.com/" />
      </Helmet>
      <div
        id="astrology"
        className="relative bg-white bg-opacity-80 text-center shadow-xl mt-3 transition-opacity duration-500 border-t-4"
        // style={{
        //   backgroundImage: imageLoaded ? "url('/image/bg/Astrology__bg.webp')" : "none",
        //   backgroundSize: "cover",
        //   backgroundPosition: "center",
        //   backgroundAttachment: "fixed", // ✅ Fixes zoom issue
        // }}
      >
        {/* Dark Overlay */}
        <div className="absolute inset-0 bg-yellow-50 bg-opacity-80"></div>
        {/* Content Wrapper */}
        <div className="relative z-10 p-6 sm:p-12 max-w-4xl mx-auto bg-yellow-50 opacity-80 w-screen">
          <Helmet>
            <title>{data.title[language]}</title>
            <meta name="description" content={data.seodescription} />
            <meta name="keywords" content={data.keyword} />
            <meta property="og:title" content={data.title[language]} />
            <meta
              property="og:description"
              content="Discover personalized astrology services."
            />
            <meta property="og:url" content="https://astromahamaya.com/" />
          </Helmet>
          {/* Title */}
          <h2 className="text-4xl md:text-5xl font-bold text-black mt-8 sm:mt-0">
            {data.title[language]}
          </h2>

          {/* Description */}
          <p className="text-sm sm:text-base text-gray-800 mt-4 sm:mt-6 leading-relaxed">
            {data.description[language]}
          </p>

          {/* Guidance Sections */}
          <div className="mt-6 sm:mt-8">
            {data.guidance.map((item, index) => (
              <div
                key={index}
                className="bg-gray-200  p-4 sm:p-6 rounded-lg mb-4 shadow-md"
              >
                <h3 className="text-xl font-semibold text-yellow-800 text-center underline">
                  {item.title[language]}
                </h3>
                <p className="text-gray-800 mt-2 text-base leading-relaxed text-center">
                  {item.content[language]}
                </p>
              </div>
            ))}
          </div>

          {/* Conclusion */}
          <p className="text-lg sm:text-xl text-gray-800 mt-6">
            {data.conclusion[language]}
          </p>

          {/* 🔮 Meet Our Astrologer Section 🔮 */}
          <div className="mt-8 sm:mt-12">
            <p className="text-xl font-semibold text-yellow-800">
              {language === "hindi"
                ? "मार्गदर्शन के लिए हमारे ज्योतिषी से मिलें"
                : "For guidance, meet our astrologer"}
            </p>

            <Link to="/contact">
              <button
                className="mt-4 bg-yellow-500 hover:bg-yellow-600 text-black font-bold py-2 px-6 rounded-full shadow-lg transition-all duration-300 text-lg"
                onClick={scrollToTop}
              >
                {language === "hindi" ? "संपर्क करें" : "Contact Us"}
              </button>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}

export default AboutAstrology;
